"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InputTextarea = exports.InputSelect = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _theme = _interopRequireDefault(require("./theme"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  display: block;\n  vertical-align: middle;\n  max-width: 32rem;\n  min-height: 36px;\n  line-height: inherit;\n  font-family: inherit;\n  background-color: transparent;\n  border-radius: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n  transition: ", " box-shadow;\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  ::-ms-clear {\n    display: none;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &[type='select'] {\n    background: #fff url(\"data:image/svg+xml;charset=utf8,", "\") no-repeat right .75rem center;\n    background-size: .5rem;\n  }\n\n  &[type='textarea'] {\n    resize: vertical;\n  }\n\n  ", " ", " ", " ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var chevron = function chevron() {
  var props = "xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'";

  var slate = '%23' + _theme["default"].colors.slate.replace('#', '');

  var pathProps = "fill='".concat(slate, "' d='M2 0L0 2h4zm0 5L0 3h4z'");
  return "%3Csvg ".concat(props, "%3E%3Cpath ").concat(pathProps, "/%3E%3C/svg%3E");
};

var Input = _styledComponents["default"].input(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.radius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.smoke;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.grey;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.info;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blue[2];
}, chevron(), _styledSystem.fontSize, _styledSystem.space, _styledSystem.width, _styledSystem.color);

Input.displayName = 'Input';
Input.propTypes = _objectSpread({
  id: _propTypes["default"].string
}, _styledSystem.propTypes.fontSize, {}, _styledSystem.propTypes.space, {}, _styledSystem.propTypes.width, {}, _styledSystem.propTypes.color);
Input.defaultProps = {
  theme: _theme["default"],
  width: 1,
  m: 0,
  py: 1,
  px: 2,
  fontSize: 2,
  color: 'inherit',
  bg: 'transparent'
};
var InputSelect = Input.withComponent('select');
exports.InputSelect = InputSelect;
var InputTextarea = Input.withComponent('textarea');
exports.InputTextarea = InputTextarea;
var _default = Input;
exports["default"] = _default;